import React from 'react';
import {connect} from 'react-redux';
import cs from 'classnames';

import Button from '~/components/common/Button';
import mapDispatch from '~/misc/mapDispatch';
import PremiumMark from '~/components/common/PremiumMark';
import {modalChange} from '~/modules/modal/actions';

import css from '../results.css';

const PremiumRowReplacer = ({showAuthModal}) => (<div
  className={cs(css.loadWrap, css.premiumReplacer)}
>
  <div className={css.premiumReplacerPart}>
    <PremiumMark/>
  </div>
  <Button
    mods={['action']}
    data-qa='view-details'
    onClick={showAuthModal}
  >
    Show Broker Info
  </Button>{' '}
</div>);


export default connect(null, mapDispatch({
  showAuthModal: () => modalChange('signup', 'premium_loads'),
}))(PremiumRowReplacer);



// WEBPACK FOOTER //
// ./src/components/search/results/PremiumRowReplacer/index.js